import { all, fork } from 'redux-saga/effects';
import getTier from './getTier';
import getTiers from './getTiers';
import getTypes from './getTypes';

export default function* events() {
  yield all([fork(getTier), fork(getTiers), fork(getTypes)]);
}
